import React from "react";
import { cn } from "../../../../../lib/utils";
import janIconSrc from "../../../../../icons/jan-icon.png";

interface JanIconProps {
  size?: "sm" | "md" | "lg" | "xl";
  className?: string;
}

const size_classes = {
  sm: "w-6 h-6",
  md: "w-8 h-8",
  lg: "w-10 h-10",
  xl: "w-12 h-12",
};

/**
 * Branded Jan assistant icon
 */
export function JanIcon({ size = "md", className }: JanIconProps) {
  return (
    <img
      src={janIconSrc}
      alt="Jan assistant"
      aria-label="Jan assistant"
      className={cn(size_classes[size], "object-contain", className)}
    />
  );
}

export default JanIcon;
